import { render, staticRenderFns } from "./ManageIP.vue?vue&type=template&id=155da876&scoped=true"
import script from "./ManageIP.vue?vue&type=script&lang=js"
export * from "./ManageIP.vue?vue&type=script&lang=js"
import style0 from "./ManageIP.vue?vue&type=style&index=0&id=155da876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155da876",
  null
  
)

export default component.exports